export default __webpack_public_path__ + "static/media/15.0a5d2b9f.jpeg";